import { createUseStyles } from 'react-jss';

export const addEditAppStyles = createUseStyles({
  container: {

  },
});
